import React, { FC } from "react";
import { useStore } from "effector-react";
import {
  $selectedPackages,
  selectedPackagesApi,
} from "../../../store/selected/selectedPackages";
import { useTranslation } from "react-i18next";
import { PackageSupplementCard } from "../../../cards";
import { Grid } from "../../../components";
import { AppConfig } from "../../../config";

const PackagesSupplements: FC = () => {
  const { t } = useTranslation(AppConfig.translationFileNames.step_Menu);
  const selectedPackages = useStore($selectedPackages);

  if (selectedPackages.length === 0) return null;

  return (
    <>
      <h2>{t("PackagesSupplements")}</h2>
      <p>{t("packagesSupplementsDescription")}</p>

      {selectedPackages.map(({ entity, supplementsServing }) => {
        if (supplementsServing.length === 0) return null;

        return (
          <div key={entity.name} style={{ marginBottom: "1.8em" }}>
            <h3 style={{ fontWeight: 500 }}>{entity.name}</h3>
            <Grid container gutter={[15, 10]}>
              {supplementsServing.map((supplement) => {
                return (
                  <Grid key={supplement.name} item xs={12} sm={6} md={12}>
                    <PackageSupplementCard
                      data={supplement}
                      onSelect={(v) => {
                        selectedPackagesApi.setSupplementServingActivity({
                          packageId: entity.id,
                          supplementId: supplement.id,
                          activityId: v,
                        });
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </div>
        );
      })}
    </>
  );
};

export default PackagesSupplements;
